import { useMemo } from 'react';
import { CentrifugalMessagesConfig, MESSAGE_STATUS, useCentrifuge } from 'react-easyrocket';
import { useMessage } from 'src/modules/messages';
import { useModalContext } from './useModalContext';
import { useFreeSpins } from './useFreeSpins';
import { getShouldReplace } from 'src/utils/getShouldReplace';
import { useBonusModalData } from 'src/modals/BonusModal/hooks/useBonusModalData';

type MessageStatus = 'info' | 'success' | 'failure';

const getMessageStatus = (status: MessageStatus): MESSAGE_STATUS => {
  if (status === 'failure') return MESSAGE_STATUS.ERROR;
  if (status === 'success') return MESSAGE_STATUS.SUCCESS;
  return MESSAGE_STATUS.INFO;
};

export const useCentrifugeMessages = () => {
  const { openMessage } = useMessage();
  const { openModal } = useModalContext();
  const { saveFreeSpins } = useFreeSpins();
  const getBonusInfo = useBonusModalData();

  const messagesConfig: CentrifugalMessagesConfig = useMemo(() => {
    return {
      USER_MESSAGE: (data) => {
        try {
          if (!data?.data?.messageType) return;
          if (!data?.data?.text) return;
          const status = data.data.messageType;
          const text = data.data.text;
          openMessage({
            type: 'USER_MESSAGE',
            props: { text: `${text}`, status: getMessageStatus(status) },
            saveToHistory: false
          });
        } catch {
          console.error('Error');
        }
      },
      USER_BONUS: async (data: any) => {
        const bonusData = await getBonusInfo(data.data?.id);

        openModal('BONUS', {
          props: {
            bonusData
          },
          replace: getShouldReplace()
        });
      },
      USER_FREESPINS: (data: any) => {
        saveFreeSpins?.(data?.data);
      }
    };
  }, [openMessage]);

  useCentrifuge({
    messagesConfig
  });
};
